<template>
	<div class="swiper-wrapscs">
		<!-- 左边按钮 -->
		<div class="left-hand" @click="slidePrev">
			<i class="el-icon-caret-left"></i>
		</div>

		<!-- vue-awesome-swiper -->
		<swiper ref="cardSwiper" class="card-swiper" :options="swiperOption">
			<swiper-slide v-for="(item, index) in list" :key="index" class="swiper-item">
				<div class="top-con">
					<div class="top-row">
						<div class="left">
							<img v-for="(c, ci) in item.product_list" :key="ci" :src="c.image" class="coin1" />
							<span class="name">{{ item.invest }}</span>
						</div>
						<button class="hand" @click="$emit('openSubmit', item.id)">{{$t('使用')}}</button>
					</div>
					<div class="desc">
						<span class="area">
							<span>{{$t('收益率')}}</span>
							<span class="win">{{ item.rate }}%</span>
						</span>
						<span class="area">
							<img src="@/assets/img-pc/41.86ac0a43.svg" />
							<span>{{ item.purchased_number || 0 }}</span>
						</span>
					</div>
				</div>
				<img src="@/assets/img-pc/40.153b3fc4.svg" alt="" class="line" />
			</swiper-slide>
		</swiper>

		<!-- 右边按钮 -->
		<div class="right-hand" @click="slideNext">
			<i class="el-icon-caret-right"></i>
		</div>
	</div>
</template>

<script>
export default {
	name: "CardSwiper",
	props: {
		list: {
			type: Array,
			required: true,
			default: () => [],
		},
	},
	data() {
		return {
			swiperOption: {
				slidesPerView: "auto", // 根据内容自动宽度
				spaceBetween: 30,      // 卡片间距
				loop: true,            // 无限循环
				speed: 600,            // 动画切换速度
				autoplay: {
					delay: 5000,             // 5s 切换一次
					disableOnInteraction: false, // 用户操作后继续自动轮播
					pauseOnMouseEnter: true,     // 鼠标悬停时暂停
				},
			}
		};
	},
	methods: {
		slidePrev() {
			this.$refs.cardSwiper.swiper.slidePrev();
		},
		slideNext() {
			this.$refs.cardSwiper.swiper.slideNext();
		},
	},
};
</script>

<style scoped lang="scss">
.swiper-wrapscs {
	display: flex;
	align-items: center;

	.left-hand,
	.right-hand {
		cursor: pointer;
		font-size: 24px;
		color: #666;
		padding: 10px;
		user-select: none;

		flex: none;
		width: 30px;
		height: 50px;
		border-radius: 99px;
		border: 2px solid #2c2c3e;
		background: #000;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 10px;
	}

	.card-swiper {
		flex: 1;
		overflow: hidden;
	}

	.swiper-item {
		width: 392px !important; // 固定卡片宽度
		position: relative;
		border-radius: 8px;
		border: 1px solid #26283a;
		-webkit-backdrop-filter: blur(3px);
		backdrop-filter: blur(3px);
		background: url("~@/assets/img-pc/113.1ca46f0d.png") no-repeat;
		background-size: cover;

		.top-con {
			padding: 12px;
		}

		.top-row {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.left {
				display: flex;
				align-items: center;

				img.coin1 {
					width: 30px;
					height: 30px;
					border-radius: 50%;

					&:not(:first-child) {
						margin-left: -14px;
					}
				}

				.name {
					font-weight: 600;
					margin-left: 5px;
					font-size: 16px;
				}
			}

			.hand {
				min-width: 100px;
				height: 36px;
				text-align: center;
				border-radius: 100px;
				background: #00f0ff;
				color: #000;
				font-size: 16px;
				border-width: 0;
				cursor: pointer;
			}
		}

		.desc {
			display: flex;
			margin-top: 10px;

			.area {
				display: flex;
				align-items: center;
				font-size: 16px;

				.win {
					color: #00f0ff;
					margin: 0 10px;
					font-weight: bold;
				}

				img {
					width: 18px;
					margin-right: 4px;
				}
			}
		}

		.line {
			width: 100%;
			margin-top: 10px;
		}
	}
}
</style>
